export default __webpack_public_path__ + "static/media/bb-00011.eea2b1fe.png";